<div class="top-products">
  <div class="section-header">
    <h3 class="title">{{ "top-products.title" | translate }}</h3>
    <a class="see-all" (click)="onSeeAllClick()">
      {{ "top-products.allProducts" | translate }}
    </a>
  </div>
  @if (products.length === 0) {
  <div class="empty-container">
    <app-empty-state
      [title]="'top-products.empty-state.title'"
      [subtitle]="'top-products.empty-state.subtitle'"
      [showImage]="true"
    />
  </div>
  } @if (products.length > 0) {
  <div>
    @for (product of products; track product.id) {
    <app-product-item
      [product]="product"
      [dropdownOpenId]="dropdownOpenId"
      (toggleDropdown)="openDropdown($event)"
      (seeTicketSoldInfo)="onSeeTicketSoldInfo($event)"
      (productDetailsRequested)="productDetailsRequested.emit($event)"
      [isTicketSold]="true"
      [eventId]="eventId"
    />
    }
  </div>
  }
</div>
